import type {MemexColumn, MemexColumnDataType, SystemColumnId} from '../../../api/columns/contracts/memex-column'

const DEFAULT_COLUMN_WIDTH = 200

export abstract class BaseColumnModel {
  readonly id: number | SystemColumnId
  readonly databaseId: number
  readonly dataType: MemexColumnDataType
  readonly name: string
  readonly position: number
  readonly defaultColumn: boolean
  readonly userDefined: boolean
  readonly issueFieldId?: number
  readonly isIssueField: boolean
  // UI designation for columns where field values are local to the project
  // Includes only user-defined fields that are not issue fields
  readonly isProjectField: boolean

  readonly settings: {
    width: number
  }

  constructor(column: MemexColumn) {
    this.id = column.id
    this.name = column.name
    this.dataType = column.dataType
    this.userDefined = column.userDefined
    this.databaseId = column.databaseId
    this.position = column.position || -1
    this.defaultColumn = column.defaultColumn
    this.issueFieldId = column.issueFieldId
    this.isIssueField = !!column.issueFieldId
    this.isProjectField = this.userDefined && !this.isIssueField
    this.settings = {
      width: DEFAULT_COLUMN_WIDTH,
      ...column.settings,
    }
  }
}
